export const trackingEvents = {
  auth: {
    clicked_forgot_password: "Clicked on Forgot Password",
    visited_reset_password: "Visited Reset Password Process from Email Link",
    password_reset_success: "Password Reset Successfully",
    clicked_contact_us_sso: "Clicked on Contact Us from SSO Modal",
    clicked_campaign_btn:
      "[Login Page Update] Clicked on Learn More (Post-test Learnings)",
    switched_workspace: "Switched Workspace"
  }
} as const;
